import { __decorate } from "tslib";
import { property } from 'lit/decorators.js';
import HelixElement from '../types/helix-element.js';
import { emitInvalidEvent, findForm } from './form-utils.js';
import { ValidationController } from './validation.controller.js';
import { createValidity } from './form-utils.js';
/**
 * To make a component that participates in forms constraint validation, extend it from this
 * class. Make sure to implement
 * - {@link HelixValidatable.validity} (getter)
 * - {@link HelixValidatable.getDefaultErrorMessage}
 *
 * And all the stuff described in {@link ValidationController} which is available for you as
 * `this.validation` protected field.
 */
export class HelixValidatable extends HelixElement {
    constructor() {
        super(...arguments);
        this.disabled = false;
        this.errorText = '';
        this.lastValidity = createValidity();
        this.validation = new ValidationController(this);
    }
    getForm() {
        return findForm(this);
    }
    checkValidity() {
        if (this.validity.valid) {
            return true;
        }
        emitInvalidEvent(this);
        return false;
    }
    setCustomValidity(message) {
        this.validation.setCustomValidity(message);
    }
    reportValidity() {
        const validity = this.validity;
        // some inputs mutate their validity, therefore we have to create a copy
        for (const key in validity) {
            if (validity[key]) {
                // save validity to check if it has changed
                // (to not distract user with constantly changing error message)
                this.lastValidity = createValidity(key);
            }
        }
        if (!validity.valid) {
            if (emitInvalidEvent(this)) {
                this.validation.showError = true;
            }
            if (this.validation.hasCustomValidity) {
                this.validation.updateCustomValidity();
            }
            else {
                this.validation.checkValidityMapping();
                this.validation.errorText = this.getDefaultErrorMessage(validity);
            }
            return false;
        }
        this.validation.showError = false;
        return true;
    }
    get validationMessage() {
        if (!this.validation.hasCustomValidity) {
            this.validation.errorText = this.getDefaultErrorMessage(this.validity);
        }
        return this.validation.validationMessage;
    }
}
__decorate([
    property({ type: Boolean, reflect: true })
], HelixValidatable.prototype, "disabled", void 0);
__decorate([
    property({ type: String })
], HelixValidatable.prototype, "form", void 0);
__decorate([
    property({ type: String, attribute: 'error-text' })
], HelixValidatable.prototype, "errorText", void 0);
__decorate([
    property({ type: Boolean, attribute: 'show-error' })
], HelixValidatable.prototype, "showError", void 0);
//# sourceMappingURL=helix-validatable.js.map